import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { http, formatApiError } from "../lib/api";

const inp = "w-full border border-slate-300 rounded-md px-3 py-2 text-sm mt-1";

export const SetPasswordDialog = ({ target, endpoint, onClose }) => {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const mismatch = pw2 && pw !== pw2;
  const save = async () => {
    setBusy(true);
    try {
      await http.put(endpoint, { new_password: pw });
      toast.success(`Mot de passe défini pour ${target.name} — ses appareils ont été déconnectés`);
      onClose();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!target} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="set-password-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">Mot de passe de {target?.name}</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Au moins 10 caractères, avec des lettres et des chiffres. L'utilisateur sera déconnecté de tous ses appareils et devra se reconnecter avec ce mot de passe.</p>
        <label className="block text-xs text-slate-500">Nouveau mot de passe<input type="password" autoComplete="new-password" className={inp} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="set-password-input" /></label>
        <label className="block text-xs text-slate-500">Confirmer<input type="password" autoComplete="new-password" className={inp} value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="set-password-confirm" /></label>
        {mismatch && <p className="text-xs text-rose-600" data-testid="set-password-mismatch">Les deux mots de passe ne correspondent pas</p>}
        <div className="flex justify-end gap-2 mt-2">
          <button onClick={onClose} className="px-4 py-2 text-sm rounded-md border border-slate-300" data-testid="set-password-cancel">Annuler</button>
          <button onClick={save} disabled={busy || pw.length < 10 || pw !== pw2} className="px-4 py-2 text-sm rounded-md bg-[#0B2A7A] text-white font-semibold disabled:opacity-40" data-testid="set-password-save">{busy ? "Enregistrement…" : "Définir le mot de passe"}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
